import DashboardPage from "../pages";
import ConvenioViewList from "./convenios/convenio-view/convenio-view";
import ConveniosList from "./convenios/convenios-list/convenios-list";
import Perfil from "./perfil/perfil";
import PracticasEnviar from "./practicas/practicas-enviar/practicas-enviar";
import PracticasInformes from "./practicas/practicas-informes/practicas-informes";
import PracticasList from "./practicas/practicas-list/practicas-list";
import PracticasRemitoAdmin from "./practicas/practicas-remito-admin/practicas-remito-admin";
import PrecargaSempre from "./practicas/precarga-sempre/precarga-sempre";
import PrecargaSempreAdmin from "./sempre/precarga-sempre-admin/precarga-sempre-admin";
import SempreImportacion from "./sempre/sempre-importacion/sempre-importacion";
import SempreInformes from "./sempre/sempre-informes/sempre-informes";

const AppRoutes = [
  {
    path: "/",
    element: <DashboardPage />,
  },
  {
    path: "/practicas",
    element: <PracticasList />,
  },
  {
    path: "/practicas/list",
    element: <PracticasList />,
  },
  {
    path: "/practicas/precarga-sempre",
    element: <PrecargaSempre />,
  },
  {
    path: "/practicas/informes",
    element: <PracticasInformes />,
  },
  {
    path: "/practicas/enviar",
    element: <PracticasEnviar />,
  },
  {
    path: "/practicas/remito-admin",
    element: <PracticasRemitoAdmin />,
  },
  {
    path: "/sempre",
    element: <SempreImportacion />,
  },
  {
    path: "/sempre/precarga",
    element: <PrecargaSempreAdmin />,
  },
  {
    path: "/sempre/importacion",
    element: <SempreImportacion />,
  },
  {
    path: "/sempre/informes",
    element: <SempreInformes />,
  },
  {
    path: "/convenios",
    element: <ConveniosList />,
  },
  {
    path: "/convenios/view/:id",
    element: <ConvenioViewList />,
  },
  {
    path: "/perfil",
    element: <Perfil />,
  },
];

export default AppRoutes;
